export default "__VITE_ASSET__DOH9rVpe__"